import React from 'react';
import DOMPurify from 'dompurify';

interface LinkResultProps {
  url: string;
  title: string;
  description: string;
  icon?: string;
  thumbnail?: string;
}

const LinkResult: React.FC<LinkResultProps> = ({ url, title, description, icon, thumbnail }) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="block h-full w-full transition-colors duration-200"
    >
      <div className="flex h-full w-full">
        {/* Left side - Icon and content */}
        <div className="flex-1 flex flex-col p-2 overflow-hidden">
          <div className="flex items-start gap-3 mb-2">
            {icon && (
              <img
                src={icon}
                alt=""
                className="w-8 h-8 rounded flex-shrink-0"
              />
            )}
            <h3 className="text-base font-medium text-[var(--rhea-text-primary)] line-clamp-2">
              {title}
            </h3>
          </div>
          <p 
            className="text-sm text-[var(--rhea-text-secondary)] line-clamp-2"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
          />
          <p className="text-xs text-[var(--rhea-accent-primary)] mt-2 truncate">
            {url}
          </p>
        </div>

        {/* Right side - Thumbnail */}
        {thumbnail && (
          <div className="w-1/3 max-h-full flex-shrink-0">
            <img
              src={thumbnail}
              alt=""
              className="w-full h-full object-cover rounded"
            />
          </div>
        )}
      </div>
    </a>
  );
};

export default LinkResult;